import React from 'react'
import ReactDOM from 'react-dom'
import BaseInputComponent from './BaseInputComponent'

class CheckboxComponent extends BaseInputComponent {

  render() {
    return <div className={`form-group ${this.state.isInvalid ? 'has-error' : ''}`}><label
      className='form-control-static'><input id={this.props.id}
                                             className="checkbox" disabled={this.props.isStatic}
                                             onChange={(event) => {this.handleChange(event.target.checked)}}
                                             type="checkbox"
                                             checked={this.getValue()}/></label></div>
  }
}

export default CheckboxComponent;



// WEBPACK FOOTER //
// ./src/components/common/CheckboxComponent.js